import React, { createContext, useContext, ReactNode } from 'react';
import { DIRECTORY_TYPE_GENERAL } from '../../../config/dirs';

interface AvailableTypesContextType {
  availableTypes: string[];
  defaultType?: string;
}

const AvailableTypesContext = createContext<AvailableTypesContextType | null>({
  availableTypes: [DIRECTORY_TYPE_GENERAL],
  defaultType: DIRECTORY_TYPE_GENERAL,
});

interface AvailableTypesProviderProps {
  children: ReactNode;
  availableTypes: string[];
  defaultType?: string;
}

export const DirectoryAvailableTypeProvider: React.FC<
  AvailableTypesProviderProps
> = ({ children, availableTypes, defaultType }) => {
  return (
    <AvailableTypesContext.Provider value={{ availableTypes, defaultType }}>
      {children}
    </AvailableTypesContext.Provider>
  );
};

export const useAvailableTypes = (): AvailableTypesContextType => {
  const context = useContext(AvailableTypesContext);

  if (!context) {
    throw new Error(
      'useAvailableTypes must be used within an AvailableTypesProvider',
    );
  }

  return context;
};
